<template>
    <div class="form">
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
        >
            <v-container fluid>
                <v-layout row>
                    <div class="info-block">
                        Add info about driver
                    </div>
                </v-layout>
                <v-layout row wrap>
                    <v-flex md6>
                        <v-layout row v-if="errors !== null">
                            <v-flex md12>
                                <div class="content-wrapper">
                                    <div class="error-block">
                                        <div class="title">Errors</div>
                                        <p v-html="errors"></p>
                                    </div>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Name <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-model="form.name"
                                    label="Insert name"
                                    :rules="rules.name"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">First name <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-model="form.firstName"
                                    label="Insert first name"
                                    :rules="rules.firstName"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Last name <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-model="form.lastName"
                                    label="Insert last name"
                                    :rules="rules.lastName"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex md6>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Phone number <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <v-text-field
                                    v-model="form.phoneNumber"
                                    label="Insert phone number"
                                    :rules="rules.phoneNumber"
                                    required
                                    outline
                                    single-line
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
<!--                        <v-layout row>-->
<!--                            <v-flex xs5>-->
<!--                                <div class="label text-xs-right">-->
<!--                                    <span class="text-xs-right">Organization <span class="required">*</span></span>-->
<!--                                </div>-->
<!--                            </v-flex>-->
<!--                            <v-flex xs7>-->
<!--                                -->
<!--                            </v-flex>-->
<!--                        </v-layout>-->
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">Fleet <span class="required">*</span></span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <fleet-autocomplete v-model="form.fleet" :disabled="!!form.vehicle" :rules="rules.fleet"></fleet-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row>
                            <v-flex xs4>
                                <div class="label text-xs-right">
                                    <span class="text-xs-right">User</span>
                                </div>
                            </v-flex>
                            <v-flex xs8>
                                <user-autocomplete v-model="form.user"></user-autocomplete>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-layout row class="buttons">
                        <v-flex xs4>
                            <sp-button @click.native="goBack" text="Go Back" small-icon icon="go-back" sp-class="go-back"></sp-button>
                        </v-flex>
                        <v-flex xs8 class="right text-xs-right">
                            <sp-button @click.native="validate" text="Save" icon="download"></sp-button>
                        </v-flex>
                    </v-layout>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
import SpButton from '@/components/forms/Button'
import router from '@/router/routes'
import FleetAutocomplete from '@/views/Fleets/components/FleetAutocomplete'
import UserAutocomplete from '@/views/Users/components/UserAutocomplete'

export default {
    name: 'DriverForm',
    components: {
        UserAutocomplete,
        FleetAutocomplete,
        SpButton
    },
    props: {
        handler: {
            type: Function,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        isEditMode: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data () {
        return {
            valid: false,
            errors: null,
            rules: {
                name: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 50 >= v.trim().length) || 'Name must be at least 3 and less than 50 characters',
                    v => (v === v.trim()) || 'Name cannot have leading or trailing spaces'
                ],
                firstName: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 50 >= v.trim().length) || 'First name must be at least 3 and less than 50 characters',
                    v => (v.length && this.validateAlphabetical(v)) || 'First name must consist of letters without diacritics'
                ],
                lastName: [
                    v => ((v || '').trim().length && 3 <= v.trim().length && 50 >= v.trim().length) || 'Last name must be at least 3 and less than 50 characters',
                    v => (v.length && this.validateAlphabetical(v)) || 'Last name must consist of letters without diacritics'
                ],
                phoneNumber: [
                    v => (v.length && this.validatePhone(v)) || 'Invalid phone number format',
                    v => ((v || '').trim().length && 3 <= v.trim().length && 50 >= v.trim().length) || 'Phone number must be at least 3 and less than 50 characters'
                ],
                organization: [
                    v => !!v || 'Organization is required'
                ],
                fleet: [
                    v => !!v || 'Fleet is required'
                ]
            }
        }
    },
    computed: {
    },
    methods: {
        async validate () {
            this.valid = this.$refs.form.validate()
            if (!this.valid) {
                return false
            }

            try {
                this.errors = null
                await this.handler(this.form)
            } catch (e) {
                this.errors = e.message
            }
        },
        goBack () {
            router.back()
        },
        validateEmail (email) {
            let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return re.test(String(email).toLowerCase())
        },
        validatePhone (phone) {
            let re = /^([0-9+()\- ]+)$/
            return re.test(String(phone).toLowerCase())
        },
        validateAlphabetical (value) {
            let re = /^[a-zA-Z]*$/
            return re.test(String(value))
        }
    }
}
</script>

<style scoped>

</style>
